import * as Yup from "yup";
import { emailRegExp } from "../../helpers";
import moment from "moment";

export const SelfStepOneFormValidationSchema = Yup.object({
    firstName: Yup.string()
        .required("FirstNameIsRequired")
        .min(
            3,
            "FirstNameMinLength"
        )
        .matches(
            /^(?:[^a-zA-Z]*[a-zA-Z]){3,}.*$/, "FirstNameMinLetters"
        ),
    lastName: Yup.string()
        .required("LastNameIsRequired")
        .min(
            3,
            "LastNameMinLength"
        )
        .matches(
            /^(?:[^a-zA-Z]*[a-zA-Z]){3,}.*$/, "LastNameMinLetters"
        ),
    dob: Yup.date().required("DateOfBirthIsRequired"),
    nationality: Yup.string().required(
        "NationalityIsRequired"
    ),
    phone: Yup.string()
        .required("Phone number is required")
        .test(
            "is-valid-phone",
            "Please enter a valid phone number",
            function (value) {
                if (!value) return false;

                const input = document.querySelector(
                    `input[name="${this.path}"]`
                );

                // ⛔ jQuery ya plugin not ready → skip validation
                if (
                    !input ||
                    !window.$ ||
                    !window.$.fn ||
                    !window.$.fn.intlTelInput
                ) {
                    return true;
                }

                const $input = window.$(input);

                try {
                    const isValid = $input.intlTelInput("isValidNumber");
                    return isValid;
                } catch (e) {
                    return true;
                }
            }
        ),
    email: Yup.string()
        .required("EmailAddressIsRequired")
        .matches(emailRegExp, "InvalidEmailFormat"),
    country: Yup.string().required("CountryIsRequired"),
    city: Yup.string().required("CityIsRequired"),
    // state: Yup.string().required("State is required"),
    // address_first: Yup.string()
    //     .required("Addres Line 1 is required")
    //     .min(
    //         3,
    //         "Addres Line 1 must be at least 3 characters long"
    //     )
    //     .matches(
    //         /^(?:[^a-zA-Z]*[a-zA-Z]){3,}.*$/, "Addres Line 1 must contain at least 3 letters"
    //     ),
    // lots: Yup.array().notRequired()
    // .when("lotRequired", {
    //     is: (slug) => slug === true,
    //     then: (schema) =>
    //         schema
    //             .min(1, "At least one lot is required")
    //             .required("At least one lot is required"),
    //     otherwise: (schema) => schema.notRequired(),
    // })
});

export const SelfStepOneFormLiveValidationSchema = Yup.object({
    firstName: Yup.string()
        .required("FirstNameIsRequired")
        .min(
            3,
            "FirstNameMinLength"
        )
        .matches(
            /^(?:[^a-zA-Z]*[a-zA-Z]){3,}.*$/, "FirstNameMinLetters"
        ),
    // lastName: Yup.string()
    //     .required("LastNameIsRequired")
    //     .min(
    //         3,
    //         "LastNameMinLength"
    //     )
    //     .matches(
    //         /^(?:[^a-zA-Z]*[a-zA-Z]){3,}.*$/, "LastNameMinLetters"
    //     ),
    // dob: Yup.date().required("DateOfBirthIsRequired"),
    nationality: Yup.string().required(
        "NationalityIsRequired"
    ),
    phone: Yup.string()
        .required("Phone number is required")
        .test(
            "is-valid-phone",
            "Please enter a valid phone number",
            function (value) {
                if (!value) return false;

                const input = document.querySelector(
                    `input[name="${this.path}"]`
                );

                // ⛔ jQuery ya plugin not ready → skip validation
                if (
                    !input ||
                    !window.$ ||
                    !window.$.fn ||
                    !window.$.fn.intlTelInput
                ) {
                    return true;
                }

                const $input = window.$(input);

                try {
                    const isValid = $input.intlTelInput("isValidNumber");
                    return isValid;
                } catch (e) {
                    return true;
                }
            }
        ),
    email: Yup.string()
        .required("EmailAddressIsRequired")
        .matches(emailRegExp, "InvalidEmailFormat"),
    country: Yup.string().required("CountryIsRequired"),
    // city: Yup.string().required("CityIsRequired"),
    // state: Yup.string().required("State is required"),
    // address_first: Yup.string()
    //     .required("Addres Line 1 is required")
    //     .min(
    //         3,
    //         "Addres Line 1 must be at least 3 characters long"
    //     )
    //     .matches(
    //         /^(?:[^a-zA-Z]*[a-zA-Z]){3,}.*$/, "Addres Line 1 must contain at least 3 letters"
    //     ),
    // lots: Yup.array().notRequired()
    // .when("lotRequired", {
    //     is: (slug) => slug === true,
    //     then: (schema) =>
    //         schema
    //             .min(1, "At least one lot is required")
    //             .required("At least one lot is required"),
    //     otherwise: (schema) => schema.notRequired(),
    // })
});
export const PrincipalStepOneFormValidationSchema = Yup.object({
    firstName: Yup.string()
        .required("PrincipalsFirstNameIsRequired")
        .min(
            3,
            "PrincipalsFirstNameMinLength"
        )
        .matches(
            /^(?:[^a-zA-Z]*[a-zA-Z]){3,}.*$/, "PrincipalsFirstNameMinLetters"
        ),
    lastName: Yup.string()
        .required("PrincipalsLastNameIsRequired")
        .min(
            3,
            "PrincipalsLastNameMinLength"
        )
        .matches(
            /^(?:[^a-zA-Z]*[a-zA-Z]){3,}.*$/, "PrincipalsLastNameMinLetters"
        ),
    id_type: Yup.string().required(
        "PrincipalsIdTypeIsRequired"
    ),
    id_number: Yup.string()
        .required("PrincipalsIdNumberIsRequired")
        .length(8, "IdNumberMustBeExactly8Characters")
        .matches(/^[A-Za-z0-9]+$/, "OnlyLettersAndNumbersAllowed")
    ,

    poa_expiry_date: Yup.date()
        .transform((_, value) =>
            value instanceof Date ? value : value ? new Date(value) : null
        )
        .required("PoaExpiryDateIsRequired")
        .test(
            "is-future-date",
            "PoaExpiryDateMustBeFutureDate",
            (value) => value && moment(value).isAfter(moment(), "day")
        ),


    phone: Yup.string()
        .required("Phone number is required")
        .test(
            "is-valid-phone",
            "Please enter a valid phone number",
            function (value) {
                if (!value) return false;

                const input = document.querySelector(
                    `input[name="${this.path}"]`
                );

                // ⛔ jQuery ya plugin not ready → skip validation
                if (
                    !input ||
                    !window.$ ||
                    !window.$.fn ||
                    !window.$.fn.intlTelInput
                ) {
                    return true;
                }

                const $input = window.$(input);

                try {
                    const isValid = $input.intlTelInput("isValidNumber");
                    return isValid;
                } catch (e) {
                    return true;
                }
            }
        ),
    email: Yup.string()
        .required("PrincipalsEmailAddressIsRequired")
        .matches(emailRegExp, "InvalidEmailFormat"),
    // lots:Yup.array().notRequired()
    // .when("lotRequired", {
    //     is: (slug) => slug === true,
    //     then: (schema) =>
    //         schema
    //             .min(1, "At least one lot is required")
    //             .required("At least one lot is required"),
    //     otherwise: (schema) => schema.notRequired(),
    // })
});